import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useLang, scrollToId } from "@/i18n";

const Navbar = () => {
  const { lang, setLang, t } = useLang();
  const [open, setOpen] = useState(false);

  const links = [
    { id: "histoire", label: t.nav.story },
    { id: "carte", label: t.nav.menu },
    { id: "galerie", label: t.nav.gallery },
    { id: "infos", label: t.nav.info },
  ];

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-[#EBDDC6]/60 bg-[#FDF6EC]/85 backdrop-blur-xl" data-testid="main-nav">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <button onClick={() => go("accueil")} className="text-left" data-testid="nav-logo">
          <span className="font-display text-lg font-semibold tracking-wide text-[#3B2A1E]">Les Retrouvailles</span>
          <span className="ml-2 font-mono2 text-[10px] uppercase tracking-[0.25em] text-[#A9761F]">de la Douce</span>
        </button>

        <nav className="hidden items-center gap-7 lg:flex">
          {links.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} data-testid={`nav-link-${l.id}`}
              className="text-sm text-[#7A6753] transition-colors duration-300 hover:text-[#E07A2B]">
              {l.label}
            </button>
          ))}
          <div className="flex items-center gap-1 rounded-full border border-[#EBDDC6] p-0.5" data-testid="lang-switcher">
            {["fr", "nl"].map((l) => (
              <button key={l} onClick={() => setLang(l)} data-testid={`lang-${l}`}
                className={`rounded-full px-2.5 py-1 text-xs font-medium uppercase transition-colors duration-300 ${lang === l ? "bg-[#E07A2B] text-[#3B2A1E]" : "text-[#A08B74] hover:text-[#3B2A1E]"}`}>
                {l}
              </button>
            ))}
          </div>
          <button onClick={() => go("reservation")} data-testid="nav-cta-reserver"
            className="rounded-full bg-[#E07A2B] px-5 py-2 text-sm font-semibold text-[#3B2A1E] transition-all duration-300 hover:bg-[#E89B4E] hover:shadow-[0_0_24px_rgba(224,122,43,0.35)]">
            {t.nav.cta}
          </button>
        </nav>

        <button className="lg:hidden text-[#3B2A1E]" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-[#EBDDC6]/60 bg-[#FDF6EC] px-4 pb-4 pt-2 lg:hidden" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} data-testid={`nav-mobile-link-${l.id}`}
              className="block w-full py-2 text-left text-[#7A6753]">{l.label}</button>
          ))}
          <div className="mt-2 flex items-center gap-2">
            {["fr", "nl"].map((l) => (
              <button key={l} onClick={() => setLang(l)} data-testid={`lang-mobile-${l}`}
                className={`rounded-full px-3 py-1 text-xs uppercase ${lang === l ? "bg-[#E07A2B] text-[#3B2A1E]" : "text-[#A08B74]"}`}>{l}</button>
            ))}
            <button onClick={() => go("reservation")} data-testid="nav-mobile-cta"
              className="ml-auto rounded-full bg-[#E07A2B] px-4 py-2 text-sm font-semibold text-[#3B2A1E]">{t.nav.cta}</button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
